var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 40,
    viewBox: "0 0 86 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.8838 39.083C82.7199 39.083 85.0191 36.7839 85.0191 33.9478C85.0191 31.1116 82.7199 28.8125 79.8838 28.8125C77.0477 28.8125 74.7485 31.1116 74.7485 33.9478C74.7485 36.7839 77.0477 39.083 79.8838 39.083Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6304 0.445312C6.68598 2.45497 0 10.4405 0 19.9936C0 29.5468 6.68598 37.5323 15.6304 39.5419C14.8454 38.5854 14.3744 37.3608 14.3744 36.0274V3.9598C14.372 2.62647 14.8454 1.40183 15.6304 0.445312Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1445 0.375C24.9658 1.34118 25.4634 2.59239 25.4634 3.95954V36.0272C25.4634 37.3943 24.9658 38.6455 24.1445 39.6117C33.2436 37.718 40.0817 29.6552 40.0817 19.9934C40.0817 10.3315 33.2436 2.26872 24.1445 0.375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3008 8.31641V19.1353L53.4481 8.31641H43.3008Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.835 39.1981H54.4871L70.12 8.31641H58.3253L42.835 39.1981Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3739 39.1976V28.4102L59.3184 39.1976H70.3739Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.88bfa0ce0cb9d48e9d47b12dc2a5106b.svg";
export { ForwardRef as ReactComponent };